export default __webpack_public_path__ + "static/media/Img0114.38e2ae96.jpg";